// Local translations
export const T = {
  en_GB: {
    // QL-36 — the runtime fallback (a goal form with no picker) is correct but
    // silent, so the designer is told here rather than by a puzzled advisor.
    unreachableWarning: (types: string) =>
      `No goal type is available to these client types: ${types}. Clients of those types will see the goal form without a goal-type picker. Widen the availability of a goal type below, or add one for them.`,
    clientTypePerson: "Person",
    clientTypeCompany: "Company",
    clientTypeGroup: "Group",
  },
  nb_NO: {
    unreachableWarning: (types: string) =>
      `Ingen måltype er tilgjengelig for disse kundetypene: ${types}. Kunder av disse typene ser målskjemaet uten måltypevelger. Utvid tilgjengeligheten til en måltype nedenfor, eller legg til en for dem.`,
    clientTypePerson: "Person",
    clientTypeCompany: "Bedrift",
    clientTypeGroup: "Gruppe",
  },
} as const;
